var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBioinformatics(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73,101.39H50.18l-13-13M22,81.57A8.39,8.39,0,1,1,30.37,90,8.39,8.39,0,0,1,22,81.57ZM95.89,51.09v79.25L79.13,141v26.67M63.9,67.86,74.56,78.53v35.06l-17.43,9.14v22.86M66.18,154a8.38,8.38,0,1,1-8.38-8.38A8.39,8.39,0,0,1,66.18,154Zm21.33,25.16a8.38,8.38,0,1,1-8.38-8.39A8.38,8.38,0,0,1,87.51,179.13ZM104.28,42.71a8.39,8.39,0,1,1-8.39-8.38A8.39,8.39,0,0,1,104.28,42.71ZM66.18,61a8.38,8.38,0,1,1-8.38-8.38A8.38,8.38,0,0,1,66.18,61Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "96.46 129.23 128.29 147.76 160.95 128.73 160.95 90.67 128.29 71.64 96.88 90.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 193.64,
    y1: 149.04,
    x2: 161.45,
    y2: 130.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 193.65,
    y1: 70.87,
    x2: 162.02,
    y2: 90.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.06,
    y1: 185.43,
    x2: 128.06,
    y2: 147.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 128.48,
    y1: 71.37,
    x2: 128.48,
    y2: 36.68
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioinformatics);
export default __webpack_public_path__ + "static/media/BIOINFORMATICS.e0816636bd91959c297a7760614c9dcf.svg";
export { ForwardRef as ReactComponent };